import { Component, OnInit, Input } from '@angular/core';
import { AdminServiceService } from 'src/app/_services/AdminService.service';

@Component({
  selector: 'app-emailsChart',
  templateUrl: './emailsChart.component.html',
  styleUrls: ['./emailsChart.component.css']
})
export class EmailsChartComponent implements OnInit {

  isLoadingChart = true;
  @Input() currentSubscription: any;

    /* ****************************** */
    public barChartOptions = {
      scaleShowVerticalLines: false,
      responsive: true
    };
    public barChartLabels = [];
    public barChartType = 'bar';
    public barChartLegend = true;
    public barChartData = [
      {data: [], label: '...'},
    ];
  
    /* ****************************** */

  constructor(private _adminService: AdminServiceService) { }

  ngOnInit() {
    if (this.currentSubscription.apiKey) this.loadChartData();
  }

  loadChartData() {
    this.isLoadingChart = true;

    this._adminService.getSubscriptionLogChart(this.currentSubscription.apiKey).subscribe(data => {
      this.isLoadingChart = false;
      this.barChartLabels = data["labels"];
      this.barChartData = data["series"];

    });    
  }

}
